import React, { useEffect } from 'react'
import { Box, Typography } from '@mui/material'

import { AppLinearProgress, AppLinksBlock } from '@components'
import { reportListCellData, reportListStatus, selectedReportTypeTab } from 'Pages/ReportsAlerts/Reports/@signals'
import LoadingText from '../../LoadingText'
import { reportSearchesModalId } from '@signals'
import { REPORT_TYPE_TABS } from 'Pages/ReportsAlerts/Reports/@constants'


export default function ReportListTableRunningBlock({ rowData, isExtras }) {

	const { hasDirectSites, hasCompetitionSites, idLastExecution: idReport } = rowData
	const reportData = reportListCellData.value[idReport]
	const isRunning = rowData?.statusLastExecution === 'running'
	const isRating = selectedReportTypeTab.value === REPORT_TYPE_TABS.RATING
	const isOneWay = selectedReportTypeTab.value === REPORT_TYPE_TABS.ONE_WAYS

	useEffect(() => {
		if (isRunning && !reportListStatus.value?.includes(idReport)) {
			reportListStatus.value = [...reportListStatus.value, idReport]
		}
	}, [isRunning, idReport])

	const handleClick = () => {
		if (isRunning && !reportData?.generating) {
			reportSearchesModalId.value = idReport
		}
	}

	return <Box
		sx={{
			cursor: !reportData?.generating ? 'pointer' : '',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			width: 1,
		}}
		onClick={handleClick}
	>
		<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 1, mb: 0.5 }}>
			<LoadingText label={!reportData?.generating ? 'Running' : 'Generating'}/>
			{!reportData?.generating && (
				<Typography variant="body2" color="text.secondary" sx={{ ml: 0.5 }}>
					{reportData?.completeTasksString || <LoadingText label="" variant="caption"/>}/
					{reportData?.totalTasksString || <LoadingText label="" variant="caption"/>}
				</Typography>
			)}
		</Box>
		<Box sx={{ width: 1 }}>
			<AppLinearProgress
				actual={reportData?.percentage}
				total={100}
				generating={reportData?.generating}
			/>
		</Box>
		{reportData?.generating && (
			<Box sx={{ mt: 1 }}>
				<AppLinksBlock
					reportExecutionID={idReport}
					hasCompetitionSites={hasCompetitionSites}
					hasDirectSites={hasDirectSites}
					downMultiReport={false}
					downMultiExport={false}
					isExtras={isExtras}
					isRating={isRating}
					isOneWay={isOneWay}
				/>
			</Box>
		)}
		<Box sx={{ width: 1 }}>
			<Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.7rem', textAlign: 'center' }}>
				{!reportData?.generating && 'Click progress bar to view details'}
			</Typography>
		</Box>
	</Box>
}
